import { useLocation } from "react-router-dom";
import { useMemo } from "react";
import qs from "query-string";
import { defaults, isFunction } from "lodash";
import { useHistory } from "react-router";

export const useDefaultReportParams = (defaultValues) => {
  const { search } = useLocation();
  const history = useHistory();
  const setReportParams = (params) => {
    history.replace({
      search: qs.stringify(params),
    });
  };

  const params = useMemo(
    () => (search ? qs.parse(search) : defaultValues),
    [search]
  );
  return [defaults(params, defaultValues), setReportParams];
};

export const withDefaultReportParams =
  (defaultValues) => (BaseComponent) => (props) => {
    const [reportParams, setReportParams] = useDefaultReportParams(
      isFunction(defaultValues) ? defaultValues(props) : defaultValues
    );
    return (
      <BaseComponent
        {...props}
        item={reportParams}
        setReportParams={setReportParams}
      />
    );
  };
